module.exports = __webpack_public_path__ + "edd56e6b861bff75f46935b69b312e70.jpeg";